export const serviceUrl = '/map/';

export const apiUrl = `${serviceUrl}api/`;
